import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  createLabCategory,
  createUserAPI,
  getLabCategory,
  getUserList,
  getUserListAPI,
  getZipDetailsAPI,
  updateLabCategory,
  updateUserAPI,
} from "../../api/master/indes";
import { toast } from "react-toastify";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";
import Status from "../../MyComp/UI/form/Status";
import { Badge, Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import QualificationComponent from "../../MyComp/UI/form/QualificationComponent";
import EmailInput from "../../MyComp/UI/form/EmailInput";
import DateTimePicker from "../../pages/components/forms/DateTimePicker";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import SelectComponent from "../../MyComp/UI/form/SelectComponent";
import TextAreaInput from "../../MyComp/UI/form/TextAreaInput";
// import { Navigate } from "react-router";
import MessageProfileSidebar from "../../pages/panel/e-commerce/support/MessageProfile";
import useLogout from "../../hooks/useLogout";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { useNavigate, useLocation } from "react-router-dom";
// import { TooltipComponent } from "../../components/Component";

const User = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      mode: "onChange",
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      storeTypeDD: [],

      stateDD: [],
      cityDD: [],

      store_image: null,
      store_img: null,

      pan_image: null,
      pan_img: null,

      drug_img: null,
      drug_image: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      catalog_image: null,
      catalog_img: null,
      user_image: null,
      user_img: null,
      fssai_image: null,
      fssai_img: null,

      cheque_image: null,
      cheque_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],

      actionType: null,
    },
  });

  const { logout } = useLogout();

  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const navigate = useNavigate();
  const location = useLocation();

  const columns = [
    {
      name: "User",
      selector: (row) => row?.name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.image)}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
            alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          /> */}
          <UserAvatarCell
            row={row}
            name={row?.name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.image}`}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.name || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.email || "No email"}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      width: "250px",
      wrap: true,
    },
    {
      name: "Registration No.",
      selector: (row) => <span>{row?.registration_num || "N/A"}</span>,

      wrap: true,
    },
    {
      name: "Mobile",
      selector: (row) => <span>{row?.mobile || "N/A"}</span>,
      // width: "119px",
      wrap: true,
    },

    {
      name: "DOB",
      selector: (row) => row?.dob,
      sortable: true,
      // width: "110px",
      wrap: true,
    },
    {
      name: "Gender",
      selector: (row) => row?.gender,
      cell: (row) => (
        <Badge
          className={`text-capitalize`}
          pill
          color={`${row?.gender == "male" ? "outline-primary" : "outline-danger"}`}
        >
          {row?.gender || "N/A"}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: "City",
      selector: (row) => row?.city,
      sortable: true,
      // width: "100px",
    },
    // {
    //   name: "State",
    //   selector: (row) => row?.state,
    //   sortable: true,
    //   // width: "100px",
    // },
    {
      name: "State",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.state || "";

        return (
          <div
            title={fullAddress} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 10)}
          </div>
        );
      },
    },
    // {
    //   name: "Description",
    //   selector: (row) => row?.description,
    //   wrap: true,
    //   width: "130px",
    // },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      // width: "100px",
    },
    // {
    //   name: "Action",
    //   // width: "125px",
    //   cell: (row) => (
    //     <Button outline color="warning" size="xs" onClick={() => handleEdit(row)}>
    //       <Icon name="edit" />
    //     </Button>,
    //      <Button
    //               id={`dash-${row?.id}`}
    //               outline
    //               color="primary"
    //               size="xs"
    //               // onClick={() => handleGoDashboard(row)}
    //             >
    //               <Icon name="presentation" />
    //             </Button>
    //   ),
    // },
    {
      name: "Action",
      width: "125px",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px", // spacing between buttons
            flexWrap: "nowrap", // ❗ prevent going to next line
          }}
        >
          <Button outline color="warning" size="sm" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>

          <Button
            outline
            color="primary"
            size="sm"
            onClick={() => navigate("/user-dashboard", { state: { userId: row?.id, id: row?.id, user: row } })}
          >
            <Icon name="eye" />
          </Button>
          {/* <TooltipComponent
                  direction="top"
                  id={`dash-${row?.id}`}
                  text="View User Dashboard"
                /> */}
        </div>
      ),
    },
  ];
  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
    getUserList();
  }, []);

  const getUserList = () => {
    setLoading(true);
    getUserListAPI()
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          setTableData(res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  // const onFormSubmit = (formData) => {
  //   const body = {
  //     name: formData.name,
  //     email: formData.email,
  //     mobile: formData.mobile,
  //     dob: formData.dob ? `${formData.dob.getDate()}/${formData.dob.getMonth() + 1}/${formData.dob.getFullYear()}` : "",
  //     gender: formData.gender?.value ?? "",
  //     description: formData.description,
  //     pin_code: formData.pin_code,
  //     city: formData.district,
  //     state: formData.state,
  //     status: formData?.status?.value ?? true,
  //     ...(mode === "Edit" && { id: watch("selectedRow").id }),
  //   };

  //   setLoading(true);

  //   if (mode === "Add") {
  //     console.log("create user api body", body);
  //     createUserAPI(body)
  //       .then((res) => {
  //         setLoading(false);
  //         if (res.data.status === true) {
  //           toast.success(res.data.message);
  //           getUserList();
  //           setIsOpen(false);
  //           setMode("Add");
  //           reset();
  //         } else if (res.data.status === "expired") {
  //           toast.error(res.data.message);
  //           logout();
  //         } else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //         toast.error(err?.response?.data?.message);
  //       });
  //   }
  //   if (mode === "Edit") {
  //     console.log("update user api body", body);
  //     updateUserAPI(body)
  //       .then((res) => {
  //         setLoading(false);
  //         if (res.data.status === true) {
  //           toast.success(res.data.message);
  //           getUserList();
  //           setIsOpen(false);
  //           setMode("Add");
  //           reset();
  //         } else if (res.data.status === "expired") {
  //           toast.error(res.data.message);
  //           logout();
  //         } else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //         toast.error(err?.response?.data?.message);
  //       });
  //   }
  // };
  const onFormSubmit = (formData) => {
    console.log(formData, "faormdataaaa");
    const fd = new FormData();

    fd.append("name", formData.name);
    fd.append("email", formData.email);
    fd.append("mobile", formData.mobile);
    fd.append(
      "dob",
      formData.dob ? `${formData.dob.getDate()}/${formData.dob.getMonth() + 1}/${formData.dob.getFullYear()}` : "",
    );
    fd.append("gender", formData.gender?.value || "");
    fd.append("description", formData.description || "");
    fd.append("pin_code", formData.pin_code || "");
    fd.append("city", formData.district || "");
    fd.append("state", formData.state || "");
    fd.append("status", formData.status?.value ?? true);

    const i = watch("user_img");
    if (formData?.user_img) {
      fd.append("img", i);
    }

    if (mode === "Edit") {
      fd.append("id", watch("selectedRow")?.id);
    }

    setLoading(true);

    const apiCall = mode === "Add" ? createUserAPI : updateUserAPI;

    apiCall(fd)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          getUserList();
          setIsOpen(false);
          setMode("Add");
          reset();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    // setValue("user_img",row.image);
    const imageUrl = `${BASE_URL_IMG}${row.image}`;
    setValue("user_image", imageUrl);
    setValue("name", row.name);
    setValue("email", row.email);
    setValue("mobile", row.mobile);
    setValue("description", row.description);
    setValue("pin_code", row.pincode);
    setValue("district", row.district_name);
    setValue("state", row.state_name);
    setValue(
      "gender",
      genderOption?.find((item) => item.value === row.gender),
    );
    if (row?.dob) {
      // Convert "19/11/2007" or similar string to a Date
      const [day, month, year] = row.dob.split("/");
      const dobDate = new Date(`${year}-${month}-${day}`);
      setValue("dob", dobDate); // sets dob field in React Hook Form
    }
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
    const body = {
      pin_code: row.pin_code,
    };
    getZipDetails(body);
  };

  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const updatedStatus = watch("selectedRow")?.status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow")?.id,
      status: updatedStatus,
    };
    console.log("update status api body", formObject);
    updateUserAPI(formObject)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          getUserList();
          setIsOpen(false);
          setMode("Add");
          reset();
          setShowModal(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const genderOption = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  useEffect(() => {
    if (watch("pin_code") && watch("pin_code").toString().length === 6) {
      const body = {
        pin_code: watch("pin_code"),
      };
      getZipDetails(body);
    }
  }, [watch("pin_code")]);

  const getZipDetails = (body) => {
    console.log("get zip details", watch("pin_code"));

    setLoading(true);
    getZipDetailsAPI(body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          console.log("zip details", responseData);
          setValue("district", responseData.district_name);
          setValue("state", responseData.state_name);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  return (
    <>
      <Head title="Users" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Users
              </BlockTitle>
            </BlockHeadContent>
            {/* Admin not add user (manan sir) */}
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  if (!isOpen) {
                    setIsOpen(true);
                    setMode("Add");
                    reset();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Name"
                      name="name"
                      placeholder="Enter user name"
                      required
                    />
                  </Col>
                  <Col md="3">
                    <MyMobile
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Mobile"
                      name="mobile"
                      placeholder="Enter mobile number"
                      required
                      readOnly={mode == "Edit"}
                    />
                  </Col>
                  <Col md="3">
                    <MyEmail
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Email"
                      name="email"
                      placeholder="Enter email"
                      required
                    />
                  </Col>
                  <Col md="3">
                    <MySelect
                      options={genderOption}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Gender"}
                      name={"gender"}
                      placeholder={"select gender"}
                      required
                    />
                  </Col>
                  <Col md="3">
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="DOB"
                      name="dob"
                      placeholder="select dob"
                      // required
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Pin Code"}
                      name={"pin_code"}
                      placeholder={"Enter pin code"}
                      required
                      min={6}
                      max={6}
                      disabled={mode == "Approval"}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"District"}
                      name={"district"}
                      placeholder={"Auto filled"}
                      // required
                      disabled={mode == "Approval"}
                      readonly
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"State"}
                      name={"state"}
                      placeholder={"Auto filled"}
                      // required
                      disabled={mode == "Approval"}
                      readonly
                    />
                  </Col>
                  <Col md="3">
                    <Status
                      register={register}
                      watch={watch}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>{" "}
                  <Col md="3">
                    <ImageUpload
                      getValues={getValues}
                      design={4}
                      id="user_image"
                      watch={watch}
                      trigger={trigger}
                      setError={setError}
                      clearErrors={clearErrors}
                      label={"Profile Image"}
                      errors={errors}
                      register={register}
                      image={"user_img"}
                      image_url={"user_image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      // validateDoc
                      // approve={mode === "Approval" ? true : false}
                      // size={2048}
                    />
                  </Col>
                  <Col md="12">
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="description"
                      placeholder="Enter user's bio"
                      min={50}
                      max={500}
                      cols={1}
                      row={1}
                    />
                  </Col>{" "}
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={loading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={tableData} columns={columns} title="Users List" isLoading={loading} />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default User;
